import {
  Autocomplete,
  Button,
  Input,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addFlightCard, getDevOrders } from '../../actions/flightCardActions';
import { Order } from '@m4a3/api-client';
import { selectCraftData } from '../../selectors/liveAircraftSelectors';
import { getShortIdForOrder } from '../../utils/orderUtils';
import { FlightCard } from '../../models/flight-card.interface';

const CreateFlightCard = ({
  devOrders,
  addFlightCard,
  getDevOrders
}) => {
  const navigate = useNavigate();
  const uavs: any = useSelector(selectCraftData);
  const [hasChangedNotes, setHasChangedNotes] = useState(false);
  const [flightType, setFlightType] = useState('SITL');
  const [aircraft, setAircraft] = useState<string>(uavs ? uavs[0].uavId : '');
  const [flightCardNotes, setFlightCardNotes] = useState('');
  const [orderId, setOrderId] = useState<string>('');
  const [numberfFlights, setNumberOfFlights] = useState(100);

  useEffect(() => {
    getDevOrders();
  }, []);

  return (
    <div style={{ backgroundColor: 'white', height: '100%', padding: '12px 6px' }}>
      <div style={{ padding: 6 }}>
        <Typography>Order</Typography>
        <Autocomplete
          disablePortal
          id="dev-orders"
          value={orderId}
          onChange={(e, val) => {
            const newValue = val as unknown as {label: string, id: string};  // the default typing is incorrect
            const order = devOrders.find((o: Order) => o.id === newValue.id);
            setOrderId(newValue.id);
            if (!hasChangedNotes) {
              setFlightCardNotes(order.externalOrderId)
            }
          }}
          options={devOrders.map(o => {
            return {
              label: `${o.externalOrderId} - ${getShortIdForOrder(o)}`,
              id: o.id
            };
          })}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Type order id..." />} />
      </div>
      <div style={{ padding: 6 }}>
        <Typography>Flight type</Typography>
        <Select
          disabled={!devOrders?.length}
          value={flightType}
          onChange={e => {
            setFlightType(e.target.value);
          }}>
            <MenuItem value={'SITL'}>SITL</MenuItem>
            <MenuItem value={'VOLUME_TESTING'}>VOLUME_TESTING</MenuItem>
        </Select>
      </div>
      <div style={{ padding: 6 }}>
        <Typography>Aircraft</Typography>
        <Select
          value={aircraft}
          onChange={e => {
            setAircraft(e.target.value);
          }}>
            {uavs?.filter(uav => uav).map((uav, i) => <MenuItem key={`uav-${uav.uavId}`} value={uav.uavId}>{`MNA-${uav.uavId}`}</MenuItem>)}
      </Select>
      </div>
      <div style={{ padding: 6 }}>
        <Typography>Number of flights</Typography>
        <Input
          style={{ marginLeft: 6 }}
          value={numberfFlights}
          onChange={e => {
            setNumberOfFlights(parseInt(e.target.value))
          }}
        />
      </div>
      <div style={{ padding: 6 }}>
        <Typography>Notes</Typography>
        <Input
          style={{ marginLeft: 6 }}
          value={flightCardNotes}
          onChange={e => {
            setFlightCardNotes(e.target.value)
            setHasChangedNotes(true)
          }}
          placeholder="Add a note"
        />
      </div>
      <Button
        variant="contained"
        color="primary"
        onClick={async () => {
          await addFlightCard({
            orderId,
            note: flightCardNotes,
            noOfFlights: numberfFlights,
            aircraft,
            active: true,
            flightType,
            count: 0
          })
          navigate('../', { replace: true });
        }}>
        Create flight card
      </Button>
    </div>
  );
};

const mapStateToProps = state => ({
  devOrders: state.flightCards.devOrders,
});

const mapDispatchToProps = dispatch => ({
  getDevOrders: () => dispatch(getDevOrders()),
  addFlightCard: (flightCard: FlightCard) => dispatch(addFlightCard(flightCard)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateFlightCard);
